





















































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator'
import { APIProduct } from '../../models/api/product.model'
import { APICarrier } from '../../models/api/carrier.model'
import { APIProvider } from '../../models/api/provider.model'

@Component
export default class ProductKeywordsForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = { productKeywordEnabled: true }

    carrierId = null
    providerId = null
    providerList: APIProvider[]
    productList: APIProduct[]
    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        productKeyword: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 128) || 'Field must be less than 128 characters'
        ]
    }

    formModel: { carriers: object[]; providers: object[]; products: object[]; types: object[] } = {
        carriers: [],
        providers: [],
        products: [],
        types: [
            {
                text: 'subscription',
                value: 'subscription'
            },
            {
                text: 'unsubscription',
                value: 'unsubscription'
            },
            {
                text: 'optin',
                value: 'optin'
            },
            {
                text: 'optout',
                value: 'optout'
            },
            {
                text: 'help',
                value: 'help'
            },
            {
                text: 'info',
                value: 'info'
            }
        ]
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        await Promise.all([
            this.getCarriers(),
            this.getProviders(),
            this.getProducts()
        ])

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Product Keyword'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Product Keyword'
            this.data = {}
            this.loading = false
            break
        }
    }

    getProducts () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getProducts')
                .then(resp => {
                    if (resp.status === 200) {
                        this.productList = this.$store.state?.ProductsStore?.products
                        resolve()
                    }
                })
        })
    }

    getCarriers () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getCarriers')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map((p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getProviders () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getProviders')
                .then(resp => {
                    if (resp.status === 200) {
                        this.providerList = this.$store.state?.ProvidersStore?.providers
                        resolve()
                    }
                })
        })
    }

    updateProviders () {
        if (!this.carrierId) return
        this.formModel.providers = this.providerList.filter((p: any) => p.carrierId.carrierId === this.carrierId).map((p: any) => {
            return {
                text: p.providerName,
                value: p.providerId
            }
        })
    }

    updateProducts () {
        if (!this.providerId) return
        this.formModel.products = this.productList.filter((p: any) => p.providerId.providerId === this.providerId).map((p: any) => {
            return {
                text: p.productName,
                value: p.productId
            }
        })
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getProductKeywordsById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.ProductKeywordsStore.productkeywordForm
                    this.carrierId = this.formData.productId.providerId.carrierId.carrierId
                    this.updateProviders()
                    this.providerId = this.formData.productId.providerId.providerId
                    this.updateProducts()
                    this.formData.productId = this.formData.productId.productId
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editProductKeywords', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'ProductKeywords'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createProductKeywords', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'ProductKeywords'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
